import { createVanIconComponent } from "./van"

const Qr = createVanIconComponent("qr")
export default Qr
